// extracted by mini-css-extract-plugin
export default {"section":"search_section__jofHN","input":"search_input__jhtkF","button":"search_button__vl3u3"};